import { useAuth } from "../../stores/auth";
import { useLocation } from "@tanstack/react-router";
import { eexCapabilitiesFor } from "../../lib/eex-access";
import type { EexCapability } from "@chro/shared";

const writeByPath: Record<string, EexCapability> = {
  "/eex/trades": "trades.manage", "/eex/quotes": "quotes.manage", "/eex/fx": "fx.manage",
  "/eex/matching": "matching.manage", "/eex/positions-tree": "matching.manage",
  "/eex/statements": "statements.import", "/eex/settings": "settings.personal",
};
// Existing role/ownership checks are supplemented by category and user grants.
export function useEexRole() {
  const user = useAuth(s => s.user);
  const path = useLocation({ select: location => location.pathname });
  const role = user?.role;
  const capability = writeByPath[path];
  return {
    role,
    canWrite: (role === "company_admin" || role === "trader") && (!capability || !!user && eexCapabilitiesFor(user)[capability]),
    isAdmin: role === "company_admin" || role === "global_admin",
  };
}
